(function () {
  'use strict';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = parseInt(cents, 10);
    }

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format);
    }

    var value = (cents / 100).toFixed(2).replace('.', ',');
    return value + ' €';
  }

  function escapeHtml(text) {
    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function findVariant(variants, selectedOptions) {
    return variants.find(function (variant) {
      return variant.options.every(function (option, index) {
        return option === selectedOptions[index];
      });
    });
  }

  function getSelectedOptions(root, optionCount) {
    var selected = [];

    for (var i = 1; i <= optionCount; i += 1) {
      var input = root.querySelector('[data-option-position="' + i + '"]:checked');
      selected.push(input ? input.value : '');
    }

    return selected;
  }

  function parseDetailContentLines(text) {
    if (!text) return [];

    return text
      .split('\n')
      .map(function (line) {
        return line.trim();
      })
      .filter(Boolean)
      .map(function (line) {
        var match = line.match(/^(\d+)\s*x\s+(.+)$/i);
        if (!match) return null;
        return {
          qty: parseInt(match[1], 10),
          description: match[2],
        };
      })
      .filter(Boolean);
  }

  function resolveIncludedItems(variant, config) {
    if (variant.includedItems && variant.includedItems.length) {
      return variant.includedItems;
    }

    var fallbackText = variant.detailContent || config.productDetailContent || '';
    return parseDetailContentLines(fallbackText);
  }

  function renderIncludedItems(container, items, contentTitle) {
    if (!container) return;

    if (!items || !items.length) {
      container.classList.add('product-detail__included--hidden');
      container.innerHTML = '';
      return;
    }

    container.classList.remove('product-detail__included--hidden');

    var html = '<div class="product-included" data-product-included>';
    html += '<p class="product-included__label">' + escapeHtml(contentTitle) + '</p>';

    if (items.length > 1) {
      html += '<ul class="product-included__list">';
      items.forEach(function (item) {
        html +=
          '<li class="product-included__item"><strong>' +
          escapeHtml(item.qty) +
          'x</strong> ' +
          escapeHtml(item.description) +
          '</li>';
      });
      html += '</ul>';
    } else {
      html +=
        '<p class="product-included__single"><strong>' +
        escapeHtml(items[0].qty) +
        'x</strong> ' +
        escapeHtml(items[0].description) +
        '</p>';
    }

    html += '</div>';
    container.innerHTML = html;
  }

  function updateGallery(root, positions) {
    var keep = null;

    if (positions && positions.length) {
      keep = [0].concat(
        positions.map(function (value) {
          return parseInt(value, 10);
        }),
      );
    }

    root.querySelectorAll('[data-media-index]').forEach(function (slide) {
      var index = parseInt(slide.getAttribute('data-media-index'), 10);
      var visible = !keep || keep.indexOf(index) !== -1;
      slide.classList.toggle('product-gallery__slide--hidden', !visible);
    });
  }

  function updateNotice(noticeEl, text) {
    if (!noticeEl) return;

    if (!text) {
      noticeEl.classList.add('product-detail__notice--hidden');
      noticeEl.innerHTML = '';
      return;
    }

    noticeEl.classList.remove('product-detail__notice--hidden');
    noticeEl.textContent = '';
    var paragraph = document.createElement('p');
    paragraph.textContent = text;
    noticeEl.appendChild(paragraph);
  }

  function updatePricePerKg(nodes, cents, config) {
    if (config.hidePrice || !config.showPriceByWeight || !config.weightInGrams) {
      nodes.forEach(function (node) {
        if (node) node.hidden = true;
      });
      return;
    }

    var perKilo = Math.round((cents * 1000) / config.weightInGrams);
    var formatted = formatMoney(perKilo, config.moneyFormat);
    var label = config.strings.pricePerKilo.replace('{{ price }}', formatted);

    nodes.forEach(function (node) {
      if (!node) return;
      node.hidden = false;
      node.innerHTML = escapeHtml(label) + '<sup class="product-buy-form__asterisk">*</sup>';
    });
  }

  function initAccordion(group) {
    var items = group.querySelectorAll('.product-accordion__item');

    items.forEach(function (item) {
      var trigger = item.querySelector('.product-accordion__trigger');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('product-accordion__item--open');

        items.forEach(function (other) {
          other.classList.remove('product-accordion__item--open');
          var otherTrigger = other.querySelector('.product-accordion__trigger');
          if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          item.classList.add('product-accordion__item--open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initQuantity(form) {
    var input = form.querySelector('.product-buy-form__qty-input');
    if (!input) return;

    var decrease = form.querySelector('[data-qty-decrease]');
    var increase = form.querySelector('[data-qty-increase]');

    if (decrease) {
      decrease.addEventListener('click', function () {
        var value = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, value - 1);
      });
    }

    if (increase) {
      increase.addEventListener('click', function () {
        var value = parseInt(input.value, 10) || 1;
        input.value = value + 1;
      });
    }
  }

  function initSection(section) {
    var configEl = section.querySelector('[data-product-variants]');
    if (!configEl) return;

    var config = JSON.parse(configEl.textContent);
    var accordion = section.querySelector('[data-product-accordion]');
    if (accordion) initAccordion(accordion);

    if (config.commerceEnabled === false) return;

    var form = section.querySelector('[data-product-form]');
    if (!form) return;

    var variantInput = form.querySelector('[data-variant-id]');
    var priceNodes = section.querySelectorAll('[data-product-price]');
    var ctaNodes = section.querySelectorAll('[data-product-cta-label]');
    var submitButtons = section.querySelectorAll('[data-product-submit], [data-product-sticky-submit]');
    var includedContainer = section.querySelector('.product-detail__included');
    var noticeEl = section.querySelector('[data-product-notice]');
    var pricePerKgNodes = section.querySelectorAll('[data-product-price-per-kg]');
    var shippingNodes = section.querySelectorAll('[data-product-shipping]');
    var optionInputs = form.querySelectorAll('[data-option-position]');
    var contentTitle = config.strings.contentTitle || 'Contenido';

    function applyVariant(variant) {
      if (!variant) return;

      variantInput.value = variant.id;

      if (!config.hidePrice) {
        var formattedPrice = formatMoney(variant.price, config.moneyFormat);
        priceNodes.forEach(function (node) {
          node.textContent = formattedPrice;
        });
      }

      var ctaLabel = variant.available ? config.strings.addToCart : config.strings.soldOut;
      ctaNodes.forEach(function (node) {
        node.textContent = ctaLabel;
      });

      submitButtons.forEach(function (button) {
        button.disabled = !variant.available;
        button.setAttribute('aria-disabled', variant.available ? 'false' : 'true');
      });

      shippingNodes.forEach(function (node) {
        node.hidden = !variant.available;
      });

      renderIncludedItems(includedContainer, resolveIncludedItems(variant, config), contentTitle);
      updateNotice(noticeEl, variant.notice);
      updateGallery(section, variant.galleryPositions);
      updatePricePerKg(pricePerKgNodes, variant.price, config);

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    function onOptionsChange() {
      var selected = getSelectedOptions(form, config.variants[0].options.length);
      var variant = findVariant(config.variants, selected);
      applyVariant(variant);
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', onOptionsChange);
    });

    initQuantity(form);

    var initialVariantId = variantInput.value;
    var initialVariant = config.variants.find(function (variant) {
      return String(variant.id) === String(initialVariantId);
    });

    if (initialVariant) {
      applyVariant(initialVariant);
    }
  }

  function init() {
    document.querySelectorAll('[data-product-detail]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
